/**
* @description: 上机/落机打卡记录
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch">
                <template #btns>
                    <el-button
                        type="primary"
                        icon="Plus"
                        @click="manualRecord?.open()"
                    >{{ t('attendance.manualRecord') }}</el-button>
                    <el-button
                        type="success"
                        icon="Download"
                        @click="exportData()"
                        >{{ t('attendance.export') }}</el-button
                    >
                </template>
            </hc-search>
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :loading="state.loading" :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight"
                :maxPage="maxPage" @pageChange="pageChange" @limitChange="limitChange">
                <template #operation="scope">
                    <div class="btn_box_det">
                        <el-button class="opBtn" size="small" type="primary" link
                            @click="$refs['detail'].open(scope.row)">{{ t('common.detail') }}</el-button>
                    </div>
                </template>
            </hc-table>
        </div>

        <Detail ref="detail" />
        <ManualRecord ref="manualRecord" @refresh="getSearch(searchData)" />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, onActivated, toRaw, watch } from "vue";
import { useI18n } from "vue-i18n";
import { ElMessage } from "element-plus";
import Detail from "./components/record-detail.vue";
import ManualRecord from "./components/manual-record.vue";
import { t } from "@/locale/index.js";

import { exportExcel } from "@/utils/apiBase"
import { pageListApi as userListApi } from "@/api/system/personnel";
import { pageListApi } from "@/api/attendance/record.js";
import { listToMap } from "@/utils/utils";
import { formatDisplayDateTime } from "@/utils/dateTime.js";
const myElementRef = ref();
const searchBox = ref();
const detail = ref();
const manualRecord = ref();


const { locale } = useI18n();

let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);

const buildSourceMap = () => ([
    { label: t('attendance.clockIn'), value: 1 },
    { label: t('attendance.clockOut'), value: 2 }
]);

const buildShiftTypeMap = () => ([
    { label: t('attendance.dayShift'), value: 1 },
    { label: t('attendance.nightShift'), value: 2 }
]);

const buildStatusMap = () => ([
    { label: t('attendance.normal'), value: 1 },
    { label: t('attendance.late'), value: 2 },
    { label: t('attendance.earlyLeave'), value: 3 },
    { label: t('attendance.missing'), value: 4 },
    { label: t('attendance.abnormalLocation'), value: 5 },
]);

const sourceMap = reactive(buildSourceMap());
const shiftTypeMap = reactive(buildShiftTypeMap());
const statusMap = reactive(buildStatusMap());

const getUserList = () => {
    const params = JSON.stringify({
        "page": 1,
        "limit": 9999,
        "keywords": "",
        "role_id": 0
    })
    userListApi(params).then(res => {
        searchData[0].children = res.data.map(i => {
            return { label: i.real_name, value: i.real_name }
        })
        getSearch(searchData)
    })
}

const searchData = reactive([
    { label: "", type: "select", value: "", field: 'keywords', children: [] },
    { label: "", type: "daterange", value: [], field: 'time', seditem: '', enditem: '' },
]);

const applyLabels = () => {
    searchData[0].label = t('field.realName');
    searchData[1].label = t('common.startTime');
    Object.assign(sourceMap, buildSourceMap());
    Object.assign(shiftTypeMap, buildShiftTypeMap());
    Object.assign(statusMap, buildStatusMap());
    state.column = buildColumns();
    tableHeaderFn();
};

const buildColumns = () => ([
        { prop: "id", show: false, label: "ID" },
        { show: true, type: "index", label: t('table.index'), width: 80 },
        { prop: "real_name", show: true, label: t('field.realName') },
        { prop: "mobile", show: true, label: t('field.mobile') },
        { prop: "checkin_time", show: true, label: t('detail.clockTime') },
        { prop: "source", show: true, label: t('attendance.clockType') },
        { prop: "shift_type", show: true, label: t('attendance.shiftType') },
        { prop: "status", show: true, label: t('field.status') },
        { prop: "address", show: true, label: t('detail.clockAddress') },
        { prop: "title", show: true, label: t('detail.deviceLabel') },
        { prop: "project_location_name", show: true, label: t('field.title') },
        { prop: "contents", show: true, label: t('improveDetail.submitContent') },
        { prop: "operation", show: true, label: t('table.operation') },
]);

watch(locale, applyLabels);

const state = reactive({
	loading: false,
    title: "",
    column: buildColumns(),
    offsetHeight: 0,
    tableHeader: [],
    tableData: [
//        {
//     "device_list_id": 0,
//     "checkin_time": "2025-05-13 21:26:29",
//     "user_id": 1,
//     "latitude": 30.578866,
//     "mobile": "13456214521",
//     "created_at": "2025-05-13 21:26:29",
//     "real_name": "张三",
//     "id": 1,
//     "source": 1,
//     "longitude": 114.014169,
//     "status": 2
// }
    ]
});

const init = () => {
    getUserList()
};

// 动态改变表头
const change = (item) => {
    tableHeaderFn();
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    getSearch(searchData)
}

const exportData = async () => {
    const timeData = toRaw(searchData.filter(i => i.field === 'time')[0] ?? {}).value ?? []
    if (timeData[0] == undefined || timeData[1] == undefined) {
        ElMessage.warning("请选择时间范围")
        return
    }
    const params = {
        stime: timeData[0],
        etime: timeData[1],
    }
    const keywords = searchData[0].value ?? ''
    if (keywords) {
        params.keywords = keywords
    }
    const { ok, msg } = await exportExcel('Excel/insertAccountExcel', params, '上班考勤表.xls')
    if (!ok) {
        ElMessage.error(msg || '导出失败')
    }
}

onMounted(() => {
    try {
        applyLabels();
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        tableHeaderFn();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

// 查询过来的数据
const getSearch = (params) => {
    const timeData = toRaw(searchData.filter(i => i.field === 'time')[0] ?? {}).value ?? []
    const requestParams = {
        "keywords": searchData[0].value ?? '',
        "stime": timeData[0] ?? '',
        "etime": timeData[1] ?? '',
        "page": page.value,
        "limit": limit.value
    }
    state.loading = true
		pageListApi(JSON.stringify(requestParams)).then(res => {
        maxPage.value = res?.maxPage ?? 0;
      state.tableData = res?.data?.map(item => {
        return {
         ...item,
          checkin_time: formatDisplayDateTime(item.checkin_time) || "-",
          source: listToMap(sourceMap, {})[item.source] ?? "-",
          shift_type: listToMap(shiftTypeMap, {})[item.shift_type] ?? (item.shift_type == 2 ? "夜班" : "白班"),
          status: listToMap(statusMap, {})[item.status] ?? "-",
        }
      })
    }).finally(() => {
		state.loading = false
	})
};

// 表头筛选
const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    // margin: 0 !important;
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
